var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsYellowWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#ffc500;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-96 -564)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(96 564)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2,16.082h.871a.378.378,0,0,1,.4.4l-.1,5.322a.367.367,0,0,1-.386.395H13.3a.351.351,0,0,1-.386-.4l-.1-5.314A.353.353,0,0,1,13.2,16.082Zm.962,7.152H13.066a.322.322,0,0,0-.347.359v.949a.321.321,0,0,0,.347.359h1.093a.33.33,0,0,0,.359-.359v-.949A.33.33,0,0,0,14.159,23.234ZM24.639,26.4a2.923,2.923,0,0,1-1.413,2.368l-.2.092H4.253l-.192-.087a2.843,2.843,0,0,1-1.422-2.381l0-.25,9.4-16.28.158-.119a2.78,2.78,0,0,1,2.854-.017l.173.122,9.409,16.3Zm-1.985.182-8.83-15.294a1.544,1.544,0,0,0-.368,0L4.619,26.592a1.576,1.576,0,0,0,.18.332H22.468A1.762,1.762,0,0,0,22.654,26.583Z",
    transform: "translate(94.361 555.766)",
    fill: "#ffc500"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsYellowWarning);
export default __webpack_public_path__ + "static/media/icons-yellow-warning.db7fabaf.svg";
export { ForwardRef as ReactComponent };